<template>
    <div>
        <v-modal ref="modalSocial" id="modalSocial" titulo="Login com Rede Social">
            <div slot="body">
                <p><small>Olá <b>{{ infoUser.name }}</b>, deseja fazer o login com o <b>{{ redeSocialEscolhida.nome_rede }}</b>?</small></p>
                <p><small>Caso você não seja <b>{{ infoUser.name }}</b>, faça primeiro o login na rede social com seu usuário ou use um método diferente para conectar.</small></p>
                <div class="clearfix mb-4"></div>
            </div>
            <div slot="buttons">
                <div class="col">
                    <div class="row">
                        <v-button label="Acessar" @click="autenticar"></v-button>
                        <v-button label="Cancelar" @click="cancel"></v-button>
                    </div>
                </div>
            </div>
        </v-modal>

        <p class="valor text-uppercase">Redes Sociais</p>
        <form action="" class="row">
            <div class="col">
                <div class="row" v-for="rede in redesSociais">
                    <component
                            :is="rede.componente"
                            :key="rede.componente"
                            :ref="rede.componente"
                            @login="getDataSocial"></component>
                </div>
                <div class="row">
                    <div class="col">
                        <p><small>Para fazer login pelas redes sociais você precisa ter vinculado seu cadastro do PCdoB Digital com os seus perfis nas redes sociais. Faça login normalmente e vincule seus perfis.</small></p>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import FacebookLogin from './../SocialButtons/FacebookLogin.vue'
    import GoogleLogin from './../SocialButtons/GoogleLogin.vue'

    export default {
        components: {
            FacebookLogin,
            GoogleLogin
        },
        props: {
            serial: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                redesSociais: [],
                redeSocialEscolhida: {},
                infoUser: {},
            }
        },
        methods: {
            getDataSocial(data) {
                this.$root.setLoading()
                this.$refs.modalSocial.show()
                this.redeSocialEscolhida = _.find(this.redesSociais, {'pk_id_rede_social': _.toString(data.type)})
                this.infoUser = data
            },
            autenticar() {
                localStorage.clear()
                let data = {
                    serial: this.serial,
                    grant_type: 'social',
                    fk_id_rede_social: this.infoUser.type,
                    id_user_rede_social: this.infoUser.id,
                    checa_papel: 1,
                }
                this.$resources.OAuth.post('/', data).then((response) => {
                    this.$refs.modalSocial.close()
                    this.$emit('login', response.data.data)
                }).catch((error) => {
                    console.dir(error)
                    if(error.response && error.response.data){
                        this.$root.setAlert(error.response.data.message,'danger')
                    }
                    else{
                        this.$root.setAlert('Ocorreu um erro na solicitação','danger')
                    }
                })
            },
            cancel() {
                this.$refs.modalSocial.close()
                this.$refs[this.redeSocialEscolhida.componente][0].logout()
            }
        },
        created() {
            this.$resources.RedesSociais.get('').then((response) => {
                this.redesSociais = response.data.data
            }).catch((error) => {
                console.dir(error)
            })
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Autenticacao/SocialLogin.vue